<template>
	<div class="border-b bg-white">
		<div class="flex items-center p-3 py-4 cursor-pointer bg-gray-300" :class="{'sticky top-0 z-20 shadow': showBlock}" style="top:57px" @click="toggleBlock">
			<chevron-component class="mr-1" :show="showBlock"></chevron-component>
			<h4 :class="showBlock ? 'font-bold' : 'font-normal'">
				Block {{ block.block_detail.name }} <span class="text-xs font-normal text-gray-300">{{ block.block_detail.id }}</span>
			</h4>
		</div>
		<div class="" v-show="showBlock">
			<template v-for="(floor, floorIndex) in floors">
				<div class="bg-white" v-if="filterByCategory(1,floorIndex).length">
					<div class="flex items-center justify-between p-3 pl-5 bg-gray-200 text-sm border-white cursor-pointer" :class="[!showFirstFix === floorIndex ? 'border-b' : 'border-b']" @click.self="toggleFirstFix(floorIndex)">
						<div class="flex-1 flex items-center" @click="toggleFirstFix(floorIndex)">
		                    <chevron-component class="mr-1" :show="showFirstFix === floorIndex"></chevron-component>
							<h4 class="flex-1 text-black cursor-pointer" :class="showFirstFix === floorIndex ? 'font-bold' : 'font-normal'">First Fix {{ floor }} Floor</h4>
						</div>
						<template v-if="showFirstFix === floorIndex">
						<div class="w-20 flex-shrink-0 text-center text-gray-600" v-if="isForecast">allocated</div>
						<div class="w-20 flex-shrink-0 text-center text-gray-600">stock</div>
						<div class="w-20 flex-shrink-0 text-center text-gray-600" v-if="isForecast">avail to forecast</div>
						<div class="w-20 flex-shrink-0 text-center text-gray-600" v-else>forecast</div>
						</template>
						<div class="w-24 sm:w-32 px-1 flex items-center justify-end">
							<!-- <span class="flex p-2 text-gray-600 cursor-pointer" v-if="!isForecast" @click="showSpecialOrder(1, block.block_detail.phase_id, null, block.block_detail.id, null)">
								<clipboard-icon class="w-4 h-4"></clipboard-icon>
							</span> -->
						</div>
					</div>

					<div class=" sm:pl-6" v-show="showFirstFix === floorIndex">
						<div class="flex items-center relative text-sm text-gray-800 pl-5 py-1 border-t first:border-t-0" v-for="product in filterByCategory(1, floorIndex)" :key="product.id + '' + product.floor">
							<div class="flex-1">
								{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span>
							</div>						
							<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated }}</div>
							<!-- <div class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used <= 0) || product.forecasted == 0 ? 0 : product.stock_qty }}</div> -->
							<div class="w-20 flex-shrink-0 text-center">{{ product.stock_qty > 0 ? product.forecast_received - product.forecast_ordered : 0 }}</div>
							<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">
								{{ product.allocated - product.forecasted }}
							</div>
							<div class="w-20 flex-shrink-0 text-center" v-else>
								{{ product.forecasted - product.used }}
							</div>
							<div class="w-24 sm:w-32 text-right">
								<input :ref="`firstfixqty_${product.id}`" v-if="canEditQty(product)" class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'FirstFix',floorIndex)" placeholder="qty">
								<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="isComplete(product)"></check-circle-icon>
								<template v-if="!isForecast">
									<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used && product.used < product.allocated"></clock-icon>
									<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty == 0"></alert-circle-icon>
								</template>
							</div>
						</div>
					</div>
				</div>
			</template>

			<div class="bg-gray-50" v-if="filterByCategory(2).length">
				<div class="flex items-center justify-between pl-5 bg-gray-200 text-sm border-white cursor-pointer" :class="[!showWire ? 'border-b' : 'shadow', isForecast ? 'p-3' : 'p-1']" @click.self="showWire=!showWire">
					<div class="flex-1 flex items-center" @click="showWire=!showWire">
	                    <chevron-component class="mr-1" :show="showWire"></chevron-component>
						<h4 class="flex-1 text-black cursor-pointer" :class="showWire ? 'font-bold' : 'font-normal'">Wire</h4>
					</div>
					<template v-if="showWire">
					<div class="w-20 flex-shrink-0 text-center text-gray-600" v-if="isForecast">allocated</div>
					<div class="w-20 flex-shrink-0 text-center text-gray-600">stock</div>
					<div class="w-20 flex-shrink-0 text-center text-gray-600" v-if="isForecast">avail to forecast</div>
					<div class="w-20 flex-shrink-0 text-center text-gray-600" v-else>forecast</div>
					</template>
					<div class="w-24 sm:w-32 px-1 flex items-center justify-end">
						<span class="flex p-2 text-gray-600 cursor-pointer" v-if="!isForecast" @click="showSpecialOrder(2, block.block_detail.phase_id, null, block.block_detail.id, null)">
							<clipboard-icon class="w-4 h-4"></clipboard-icon>
						</span>
					</div>
				</div>
				<div class="sm:pl-6" v-show="showWire">
					<div class="flex items-center relative text-sm text-gray-800 pl-5 py-1 border-t first:border-t-0" v-for="product in filterByCategory(2)" :key="product.id">
						<div class="flex-1">
							{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span>
						</div>
						<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated }}</div>
						<!-- <div class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</div> -->
						<div class="w-20 flex-shrink-0 text-center">{{ product.stock_qty > 0 ? product.forecast_received - product.forecast_ordered : 0 }}</div>
						<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">
							{{ product.allocated - product.forecasted }}
						</div>
						<div class="w-20 flex-shrink-0 text-center" v-else>
							{{ product.forecasted - product.used }}
						</div>
						<div class="w-24 sm:w-32 text-right">
							<input :ref="`wireqty_${ product.id }`" v-if="canEditQty(product)" class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'Wire')" placeholder="qty">
							<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="isComplete(product)"></check-circle-icon>
							<template v-if="!isForecast">
								<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used && product.used < product.allocated"></clock-icon>
								<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty == 0"></alert-circle-icon>
							</template>
						</div>
					</div>

				</div>

			</div>
			<div class="bg-white" v-if="block.units.length">
				<div class="flex items-center justify-between p-3 pl-5 bg-gray-200 border-white cursor-pointer" :class="[!showFinalFix ? '' : 'shadow']" @click="showFinalFix=!showFinalFix">
					<div class="flex-1 flex items-center">
	                    <chevron-component class="mr-1" :show="showFinalFix"></chevron-component>
						<h4 class="flex-1 text-black cursor-pointer" :class="showFinalFix ? 'font-bold' : 'font-normal'">Final Fix</h4>
					</div>
				</div>
				<div class="sm:pl-3" v-show="showFinalFix">
					<div class="relative text-sm text-gray-800 p-3 pl-4 py-1 border-t first:border-t-0" v-for="unit in block.units" :key="unit.id">
						<div class="w-full py-2 bg-white" @click="toggleUnit(unit.id)" :class="{'sticky top-0 z-10 border-b': showUnit == unit.id}" style="top:110px">
							<div class="flex items-center">
								<div class="flex-1 flex items-center">
									<chevron-component class="mr-1" :show="showUnit == unit.id"></chevron-component>
									<h4 class="flex-1 text-black cursor-pointer" :class="showUnit == unit.id ? 'font-bold' : 'font-normal'">Unit {{ unit.name }} <span class="text-xs font-normal text-gray-50">{{ unit.id }}</span></h4>
								</div>
								<!-- <div class="col-span-1 flex items-center justify-end px-1">
									<span class="flex p-2 link text-gray-600 cursor-pointer" v-if="!isForecast && isAdmin" @click="showSpecialOrder(5, block.block_detail.phase_id, null, block.block_detail.id, unit.id, unit.name)">
										<clipboard-icon class="w-4 h-4 mr-1"></clipboard-icon>
									</span>
								</div> -->
								<div class="w-20 flex-shrink-0 text-center" v-if="showUnit == unit.id && isForecast">allocated</div>
								<div class="w-20 flex-shrink-0 text-center" v-if="showUnit == unit.id">stock</div>
								<div class="w-20 flex-shrink-0 text-center leading-tight" v-if="showUnit == unit.id && isForecast">avail to forecast</div>
								<div class="w-20 flex-shrink-0 text-center" v-else-if="showUnit == unit.id">forecast</div>
								<div class="w-32 flex-shrink-0 text-right" v-if="showUnit == unit.id">
									<label>
										<input type="checkbox" class="form-checkbox h-6 w-6 border-blue-400" :id="`common_${block.block_detail.id}`" :name="`common_${block.block_detail.id}`" v-model="toggleUnitProducts" @click.stop>
									</label>
								</div>
							</div>
						</div>
                		<order-unit-component v-if="showUnit == unit.id" :phase="block.block_detail.phase_id" :block="block.block_detail.id" :unit="unit.id" :toggle="toggleUnitProducts"></order-unit-component>
					</div>
				</div>
				<div v-show="showFinalFix">
					<div class="text-sm" v-if="filterByCategory(8).length">
						<div class="flex items-center justify-between p-2 pl-6 bg-blue-300">
							<div class="flex-1 text-black font-bold">Common</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700" v-if="isForecast">allocated</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700">stock</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700" v-if="isForecast">avail to forecast</div>
							<div class="w-20 flex-shrink-0 text-center text-blue-700" v-else>forecast</div>
							<div class="w-24 sm:w-32 px-1 flex items-center justify-end">
								<!-- <span class="flex p-2 text-gray-600 cursor-pointer" v-if="!isForecast && isAdmin" @click="showSpecialOrder(8, block.block_detail.phase_id, null, block.block_detail.id, null)">
									<clipboard-icon class="w-4 h-4"></clipboard-icon>
								</span> -->
							</div>
						</div>
						
						<div class="mt-2 sm:pl-6">
							
							<div class="flex items-center relative pl-5 p-1 text-sm border-b"v-for="product in filterByCategory(8)" :key="product.id">
								<div class="flex-1 flex items-center">
									{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span>
								</div>
								<div class="sm:inline-block w-20 text-center" v-if="isForecast">{{ product.allocated }}</div>
								<!-- <div class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</div> -->
								<div class="w-20 flex-shrink-0 text-center">{{ product.stock_qty > 0 ? product.forecast_received - product.forecast_ordered : 0 }}</div>
								<div class="sm:inline-block w-20 text-center" v-if="isForecast">
									{{ product.allocated - product.forecasted }}
								</div>
								<div class="sm:inline-block w-20 text-center" v-else>
									{{ product.forecasted - product.used }}
								</div>
								<div class="w-24 sm:w-32 text-right">
									<input :ref="`commonqty_${ product.id }`" v-if="canEditQty(product)" class="w-12 sm:w-24 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'Common')" placeholder="qty">
									<check-circle-icon class="w-8 h-8 inline-block text-green-400 p-2 mr-2" v-if="isComplete(product)"></check-circle-icon>
									<template v-if="!isForecast">
										<clock-icon class="w-8 h-8 inline-block text-blue-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted > 0 && product.used < product.allocated"></clock-icon>
										<alert-circle-icon class="w-8 h-8 inline-block text-red-400 p-2 mr-2" v-if="product.stock_qty == 0 && product.forecasted == 0"></alert-circle-icon>
									</template>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<portal to="modals" v-if="specialOrder.show" :order="1">
			<special-order-modal
				:show="specialOrder.show"
				:job="job"
				:special-order="specialOrder"
				@close="closeSpecialOrder"
				@save="saveSpecialOrder"
				@reload="$emit('reload')"
				>
			</special-order-modal>
		</portal>
	</div>
</template>

<script>
import SpecialOrderModal from '../common/SpecialOrderModal.vue'
import OrderUnitComponent from './OrderUnitComponent.vue'

export default {
	props: ['job', 'block', 'activeBlock'],
	name: 'BlockComponent',

	data () {
		return {
			specialOrder: {
				show: false,
				catId: false,
				phase: false,
				area: false,
				block: false,
				location:'',
				unit: false,
			},
			role: null,
			showBlock: false,
			showFirstFix: false,
			showWire: false,
			showTools: false,
			showFinalFix: false,
			showUnit: false,
			toggleUnitProducts: false,
			chkval: false,
			first_fix_order : true,
			final_fix_gen_order : true,
			location:'',
			floors: ['Ground', 'First', 'Second', 'Third', 'Fourth', 'Fifth']
		}
	},
	watch: {
		activeBlock: function(newVal, oldVal){
			if(newVal !== this.block.block_detail.id){
				this.showBlock = false;
			}
		}
	},
	computed: {
		isForecast: function(){
			return this.location == 'Forecast Order';
		},
		notForecast: function(){
			return !this.isForecast;
		},
		filteredProducts: function () {
			if (!this.productCatId) {
				return []
			}
			return this.block.block_products.filter(product => {
				return product.category_id === this.productCatId
			})
		},
		getProductCategoryName: function () {
			return this.$store.getters.getProductCategoryNameById(this.productCatId)
		},
		isAdmin: function(){
			return this.role === 'Super Admin' || this.role === 'Administrator';
		},
		isManager: function(){
			return this.role === 'Regional Manager' || this.role === 'Site Manager';
		}
	},
	methods: {
		toggleBlock: function(){
			this.showBlock = !this.showBlock;
			if(this.showBlock){
				this.showFirstFix = false;
				this.showWire = false;
				this.showTools = false;
				this.showFinalFix = false;
				this.$emit('update:activeblock', this.block.block_detail.id);
			}
		},
		toggleFirstFix: function(floor){
			if(this.showFirstFix === floor){
				this.showFirstFix = false;
				return;
			}
			this.showFirstFix = floor;
		},
		toggleUnit: function(id){
			this.toggleUnitProducts = false;
			this.showUnit == id ? this.showUnit = false : this.showUnit = id;
		},
		selectAllFirstFix: function(){
			if(event.target.checked){
				this.$store.commit('order/addFirstFix', {
					'blockId': this.block.block_detail.id,
					'products': this.filterByCategory(1),
				});
			}else{
				this.$store.commit('order/removeFirstFix',{
					'blockId': this.block.block_detail.id
				});
			}
			// console.log(this.$store.getters['order/getOrder'])
		},
		isComplete: function(product){
			return (product.allocated - product.used) <= 0 && product.forecasted > 0;
		},
		canEditQty: function(product){
			if(this.notForecast){
				return (product.allocated - product.used > 0)
					&& product.stock_qty > 0
						&& product.forecast_received - product.forecast_ordered > 0;
			}
			return (product.allocated - product.forecasted) > 0;
		},
		modifyProductQty: function(product, event, type, floor = null){
			if(this.isForecast && (event.target.value > (product.allocated - product.forecasted))){
				event.target.value = product.allocated - product.forecasted;
			}
			if(this.notForecast && (event.target.value > (product.forecast_received - product.forecast_ordered))){
				event.target.value = product.forecast_received - product.forecast_ordered;
			}
			this.$store.commit('order/modifyProductQty', {
				'blockId': this.block.block_detail.id,
				'productId': product.id,
				'qty': event.target.value,
				'type': type,
				'floor': floor,
			});
		},
		modifyTools: function(product, event){
			// if(event.target.value > (product.allocated - product.used)){
			// 	event.target.value = product.allocated;
			// }
			// this.$store.commit('order/modifyTools', {
			// 	'blockId': this.block.block_detail.id,
			// 	'productId': product.id,
			// 	'qty': event.target.value,
			// });
		},
		ToggleFinalFixGeneral: function(){
			if(event.target.checked){
				this.$store.commit('order/addFinalFixGeneral', {
					'blockId': this.block.block_detail.id,
					'products': this.filterByCategory(6),
				});
			}else{
				this.$store.commit('order/removeFinalFixGeneral',{
					'blockId': this.block.block_detail.id
				});
			}
			// console.log(this.$store.getters['order/getOrder'])
		},
		UpdateProducts: function (location, products, blockId,event) {
			// console.log(location)
			// console.log(products)
			// console.log(blockId)
			if(event.target.checked) {
			this.$store.commit('setOrderProducts', {'key':location,'products':{'block': blockId, 'products': products}})
			}
			else
			{
				let orderproducts = this.$store.getters.getOrderProducts
				// if anyone unchecks first_fix, need to remove the product array, how?
			}
			console.log(this.$store.getters.getOrderProducts)
		},
		modifyOrder: function(product, block){
			console.log(product);
			console.log(block);
		},
		splitCategory: function (catId, howMany) {
			var chunckSize = this.filterByCategory(catId).length / howMany
			return this.$_.chunk(this.filterByCategory(catId), chunckSize)
		},
		
		filterByCategory: function (id, floor = null) {
			let filtered = this.block.block_products.filter(product => {
				return product.category_id === id
			});
			if(floor !== null){
				let filteredFloor = filtered.filter(product => {
					return product.floor === floor;
				});
				filtered = filteredFloor;
			}
			return filtered;
		},
		showSpecialOrder: function(catId, phase, area, block, unit, unit_name = null){
			this.specialOrder.show = true;
			this.specialOrder.catId = catId;
			this.specialOrder.phase = phase;
			this.specialOrder.area = area;
			this.specialOrder.block = block;
			this.specialOrder.unit = unit;
			this.specialOrder.unit_name = unit_name;
		},
		closeSpecialOrder: function(){
			this.specialOrder.show = false;
			this.specialOrder.phase = false;
			this.specialOrder.area = false;
			this.specialOrder.block = false;
			this.specialOrder.unit = false;
		},
		saveSpecialOrder: function(){
			console.log('http');
		},
		
	},
	components: {
		SpecialOrderModal,
		OrderUnitComponent
	},
	created: function () {
		this.location = this.$route.name
		this.role = this.$store.getters['auth/role']
		var firstfixpdts = this.filterByCategory(1)
		var finalfixgenpdts = this.filterByCategory(6)
		if(firstfixpdts.length > 0 && firstfixpdts[0].used > 0)
		{
			this.first_fix_order = false
		}
		if(finalfixgenpdts.length > 0 && finalfixgenpdts[0].used > 0)
		{
			this.final_fix_gen_order = false
		}
	}
}
</script>

<style lang="css" scoped>
</style>
